/**
 *
 * @param {number} value
 * @returns
 */
export default function (value) {
  if (typeof value !== "number") return 0;

  const formatter = new Intl.NumberFormat("pt-BR");

  return formatter.format(value);
}
